import axiosInstance from './axiosInstance';

const legacyModeConfig = {
  all: { endpoint: '/transaction/get_transactions', approveStatus: 1 },
  pending: { endpoint: '/pending/get_pending_transactions' },
  createApproval: { endpoint: '/transaction/get_transactions', approveStatus: 2 },
  updateApproval: { endpoint: '/transaction/get_transactions', approveStatus: 3 },
};

let optimizedListAvailable;
let optimizedCountsAvailable;
let optimizedFiltersAvailable;

const toLegacyParams = (params, mode) => {
  const { customer_id, supplier_id, include_all, ...legacyParams } = params;
  const config = legacyModeConfig[mode];
  if (config.approveStatus) legacyParams.approve_status = config.approveStatus;
  return legacyParams;
};

export const getTransactionList = async (mode, params, requestConfig = {}) => {
  if (optimizedListAvailable !== false) {
    const response = await axiosInstance('/transaction/list', 'get', { mode, ...params }, requestConfig);
    if (response?.status !== 404) {
      optimizedListAvailable = true;
      return response;
    }
    optimizedListAvailable = false;
  }

  const legacyConfig = legacyModeConfig[mode];
  return axiosInstance(legacyConfig.endpoint, 'get', toLegacyParams(params, mode), requestConfig);
};

export const getTransactionFilterOptions = async (config = {}) => {
  if (optimizedFiltersAvailable !== false) {
    const response = await axiosInstance('/transaction/filter-options', 'get', {}, config);
    if (response?.status !== 404) {
      optimizedFiltersAvailable = true;
      return response;
    }
    optimizedFiltersAvailable = false;
  }

  const [supplierResponse, customerResponse] = await Promise.all([
    axiosInstance('/supplier/get_suppliers', 'get', { pageNum: 1, pageSize: 500, keyword: '' }, config),
    axiosInstance('/customer/get_only_customers', 'get', {}, config),
  ]);
  const failedResponse = [supplierResponse, customerResponse].find((response) => !response || response.status >= 400);
  if (failedResponse) return failedResponse;
  return {
    status: 200,
    data: {
      suppliers: supplierResponse?.data?.data || [],
      customers: customerResponse?.data?.data || [],
    },
  };
};

export const getTransactionCounts = async () => {
  if (optimizedCountsAvailable !== false) {
    const response = await axiosInstance('/transaction/list-counts', 'get');
    if (response?.status !== 404) {
      optimizedCountsAvailable = true;
      return response;
    }
    optimizedCountsAvailable = false;
  }

  const response = await axiosInstance('/transaction/get_transaction_data_amount', 'get', {});
  if (!response || response.status >= 400) return response;
  return {
    status: response.status,
    data: {
      pending: response.data?.pendingTransaction?.length || 0,
      createApproval: response.data?.transactions?.filter((item) => item.approve_status === 2).length || 0,
      updateApproval: response.data?.transactions?.filter((item) => item.approve_status === 3).length || 0,
    },
  };
};

export const __resetTransactionApiCapabilitiesForTests = () => {
  optimizedListAvailable = undefined;
  optimizedCountsAvailable = undefined;
  optimizedFiltersAvailable = undefined;
};
